import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import zhHK from "./locales/zh-HK.json";
import zhCN from "./locales/zh-CN.json";

// react-i18next bootstrap. Add new locales by:
//   1. Drop /src/i18n/locales/<code>.json in place.
//   2. Import + register the resource here.
//   3. Add the code to SUPPORTED_LANGUAGES so it shows up in the switcher.
//   4. Add the code to the `languages: []` array of every country that
//      should offer it in /src/i18n/countries.js.
// See /docs/adding-a-language.md for the full checklist.

export const SUPPORTED_LANGUAGES = [
    { code: "en",    label: "English",             nativeLabel: "English" },
    { code: "zh-HK", label: "Traditional Chinese", nativeLabel: "繁體中文" },
    { code: "zh-CN", label: "Simplified Chinese",  nativeLabel: "简体中文" },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en:       { translation: en },
            "zh-HK":  { translation: zhHK },
            "zh-hk":  { translation: zhHK },   // lowercase alias
            "zh-CN":  { translation: zhCN },
            "zh-cn":  { translation: zhCN },
            zh:       { translation: zhHK },   // bare "zh" → Traditional (HK is our HQ)
        },
        fallbackLng: "en",
        supportedLngs: [...SUPPORTED_LANGUAGES.map((l) => l.code), "zh", "zh-hk", "zh-cn"],
        load: "currentOnly",
        lowerCaseLng: false,
        cleanCode: false,
        nonExplicitSupportedLngs: true,
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "perx_lang",
        },
    });

if (typeof window !== "undefined") {
    // Exposed for browser-console debugging + Playwright inspection.
    window.__perxI18n = i18n;
}

export default i18n;
